const getUiDisclosureContent = (state, disclosureId) =>
  state.content
    .map(bundle => bundle?.uiDisclosures?.find(disc => disc?.disclosureId === disclosureId) ?? null)
    .find(bundle => bundle !== null) ?? {};

export default getUiDisclosureContent;
